import { OPTIMIZATION_STRATEGY_COLORS } from '@/constants';
import { formatDateTime, getOptimizationStrategyLabel } from '@/utils/formatters';
import { EditOutlined } from '@ant-design/icons';
import { Button, Switch, Tag } from 'antd';

export const getPortfoliosTableColumns = ({
  onStatusToggle,
  onEdit,
  togglingPortfolioId,
  timezone,
}) => [
  {
    title: 'Portfolio',
    dataIndex: 'portfolioName',
    key: 'portfolioName',
    width: 250,
    sorter: true,
    sortDirections: ['ascend', 'descend'],
  },
  {
    title: 'Optimization Strategy',
    dataIndex: 'optimizationStrategy',
    key: 'optimizationStrategy',
    width: 180,
    sorter: true,
    sortDirections: ['ascend', 'descend'],
    render: (strategy) => (
      <Tag color={OPTIMIZATION_STRATEGY_COLORS[strategy] || 'default'}>
        {getOptimizationStrategyLabel(strategy)}
      </Tag>
    ),
  },
  {
    title: 'Last Optimized Date',
    dataIndex: 'lastOptimized',
    key: 'lastOptimized',
    width: 150,
    align: 'center',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
    render: (date) => formatDateTime(date, timezone),
  },
  {
    title: 'Last Submission Date',
    dataIndex: 'lastSubmission',
    key: 'lastSubmission',
    width: 150,
    align: 'center',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
    render: (date) => formatDateTime(date, timezone),
  },
  {
    title: 'LOS',
    dataIndex: 'clv',
    key: 'clv',
    width: 80,
    align: 'center',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
    render: (value) => `${value}`,
  },
  {
    title: 'Users',
    dataIndex: 'userCount',
    key: 'userCount',
    width: 80,
    align: 'center',
  },
  {
    title: 'Status',
    key: 'status',
    dataIndex: 'isActive',
    width: 100,
    align: 'center',
    sorter: true,
    sortDirections: ['ascend', 'descend'],
    render: (_, record) => (
      <Switch
        checked={record.isActive}
        onChange={(checked) => onStatusToggle(record.portfolioId, checked)}
        checkedChildren="Enabled"
        unCheckedChildren="Disabled"
        loading={togglingPortfolioId === record.portfolioId}
        disabled={!!togglingPortfolioId}
      />
    ),
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 100,
    align: 'center',
    render: (_, record) => (
      <Button type="link" icon={<EditOutlined />} onClick={() => onEdit(record.portfolioId)}>
        Edit
      </Button>
    ),
  },
];
